import React, { useState, Children } from 'react';
import { ChevronDown, BookOpen } from 'lucide-react';
type Chapter = {
  title: string;
  items: string[];
};
type Tomo = {
  number: number;
  title: string;
  subtitle: string;
  emoji: string;
  chapters: Chapter[];
  biblio: string[];
};
const tomos: Tomo[] = [{
  number: 1,
  title: 'INICIACIÓN AL RUGBY INFANTIL',
  subtitle: 'Primeros pasos con la ovalada',
  emoji: '🏉',
  chapters: [{
    title: '¿Qué es el Rugby Infantil?',
    items: ['🏉 Filosofía del rugby formativo', '🤝 Valores del rugby desde chicos', '🎯 Objetivos reales por edades', '👨‍🏫 Rol del entrenador infantil', '💬 Cómo hablarle a los chicos en clase']
  }, {
    title: 'Organización de Entrenamientos',
    items: ['📋 Cómo armar una práctica dinámica', '👥 Manejo de grupos grandes', '🧒 División por edades y niveles', '🎒 Materiales básicos para entrenar', '🔄 Cómo trabajar por estaciones']
  }, {
    title: 'Primer Contacto con la Ovalada',
    items: ['🏉 Juegos de familiarización', '✋ Manipulación de pelota', '🎯 Recepciones básicas', '🔄 Pases simples', '🧩 Coordinación general']
  }, {
    title: 'Entradas en Calor Divertidas',
    items: ['🏃 Mancha rugby', '⚡ Carreras con consignas', '🎯 Juegos de reacción', '🤾 Activaciones con pelota', '🥇 Competencias rápidas']
  }, {
    title: 'Juegos Motores Aplicados',
    items: ['🔄 Cambios de dirección', '⚡ Velocidad y reacción', '🤸 Coordinación motriz', '🧩 Circuitos dinámicos', '🤝 Juegos cooperativos']
  }, {
    title: '10 Clases Armadas',
    items: ['📋 Clase para 4-6 años', '📋 Clase para 7-9 años', '📋 Clase para grupos grandes', '📋 Clase recreativa', '📋 Clase en espacios reducidos']
  }, {
    title: 'Cómo Mantener Motivados a los Chicos',
    items: ['🔥 Dinámicas grupales', '🏆 Premios y desafíos', '👏 Refuerzo positivo', '💬 Correcciones simples']
  }],
  biblio: ['World Rugby — Rugby Ready', 'Introducción al Rugby Infantil — UAR', 'Desarrollo Motor Infantil aplicado al deporte', 'Teaching Games for Understanding']
}, {
  number: 2,
  title: 'PASES, APOYOS Y ATAQUE',
  subtitle: 'Mover la ovalada y atacar jugando',
  emoji: '⚡',
  chapters: [{
    title: 'Técnica Básica del Pase',
    items: ['🏉 Pase lateral', '💪 Posición corporal', '🔄 Pase en movimiento', '⚠️ Errores comunes', '🎯 Correcciones rápidas']
  }, {
    title: 'Recepción y Control',
    items: ['✋ Recepciones básicas', '⚡ Recepción en velocidad', '👀 Coordinación visual', '🏃 Recepción bajo presión']
  }, {
    title: 'Apoyos y Líneas de Carrera',
    items: ['🔄 Cómo enseñar apoyos', '🏃 Movimiento sin pelota', '🎯 Timing ofensivo', '⚡ Cambios de ritmo']
  }, {
    title: 'Juegos de Ataque',
    items: ['➕ Superioridad numérica', '🏉 Ataque por espacios', '⚡ Mini partidos ofensivos', '🎮 Juegos condicionados']
  }, {
    title: 'Circuitos Técnicos',
    items: ['🔁 Estaciones de pase', '🏃 Circuitos dinámicos', '⏱️ Trabajo por tiempo', '🥇 Competencias grupales']
  }, {
    title: '12 Clases Armadas',
    items: ['📋 Clase de pase', '📋 Clase de apoyos', '📋 Clase ofensiva', '📋 Clase recreativa técnica']
  }],
  biblio: ['Coaching Children Rugby', 'Rugby Skills & Drills', 'World Rugby Coaching Kids']
}, {
  number: 3,
  title: 'DEFENSA, TAG Y CONTACTO',
  subtitle: 'Aprender a defender sin perder la diversión',
  emoji: '🛡️',
  chapters: [{
    title: 'Introducción Defensiva',
    items: ['🧱 Principios defensivos', '🏃 Posición corporal', '👀 Lectura del juego', '🗣️ Comunicación defensiva']
  }, {
    title: 'Rugby Tag',
    items: ['🎀 Reglas básicas', '⚡ Juegos de tag', '🔄 Transiciones ataque-defensa', '🏉 Mini partidos tag']
  }, {
    title: 'Técnica de Tackle Infantil',
    items: ['🛡️ Postura correcta', '🤝 Contacto progresivo', '⚠️ Seguridad infantil', '💪 Trabajo con escudos']
  }, {
    title: 'Juegos Defensivos',
    items: ['🏃 Juegos de persecución', '🎯 Robo de cintas', '⚡ Defensa en espacios reducidos', '🔥 Reacción defensiva']
  }, {
    title: 'Circuitos de Contacto',
    items: ['🔁 Estaciones defensivas', '🛡️ Circuitos con escudos', '🤝 Trabajo por parejas', '🎯 Toma de decisiones']
  }, {
    title: '10 Clases Armadas',
    items: ['📋 Clase de tag rugby', '📋 Clase defensiva', '📋 Clase de tackle progresivo', '📋 Clase competitiva infantil']
  }],
  biblio: ['Rugby Ready — World Rugby', 'Coaching Rugby Safely', 'Manual de Rugby Infantil UAR']
}, {
  number: 4,
  title: 'VELOCIDAD, COORDINACIÓN Y PREPARACIÓN FÍSICA',
  subtitle: 'Chicos más rápidos, coordinados y seguros',
  emoji: '⚡',
  chapters: [{
    title: 'Desarrollo Motor Infantil',
    items: ['🧒 Capacidades por edad', '⚡ Velocidad', '🤸 Coordinación', '🛡️ Prevención de lesiones']
  }, {
    title: 'Juegos de Velocidad',
    items: ['🏃 Relevos', '⚡ Reacción visual', '🎯 Carreras competitivas', '🔥 Juegos explosivos']
  }, {
    title: 'Coordinación Aplicada',
    items: ['🔁 Escaleras', '🤸 Saltos', '🧩 Circuitos motores', '🏉 Coordinación con pelota']
  }, {
    title: 'Fuerza Infantil Segura',
    items: ['💪 Peso corporal', '🤝 Juegos de empuje', '⚖️ Equilibrio', '🛡️ Estabilidad corporal']
  }, {
    title: 'Resistencia Mediante Juegos',
    items: ['🔄 Juegos continuos', '🏉 Rugby aeróbico', '🥇 Competencias grupales', '⚡ Circuitos recreativos']
  }, {
    title: '12 Clases Armadas',
    items: ['📋 Clase física', '📋 Clase coordinativa', '📋 Clase de velocidad', '📋 Clase físico-técnica']
  }],
  biblio: ['Preparación Física Infantil', 'Long Term Athlete Development', 'Desarrollo Motor y Deporte']
}, {
  number: 5,
  title: 'JUEGOS Y SITUACIONES REALES DE PARTIDO',
  subtitle: 'Aprender rugby jugando',
  emoji: '🎮',
  chapters: [{
    title: 'Aprendizaje Mediante Juegos',
    items: ['🎯 Por qué enseñar jugando', '⚡ Adaptación de reglas', '🏉 Intensidad y diversión']
  }, {
    title: 'Mini Juegos de Rugby',
    items: ['⚔️ 1 vs 1', '⚔️ 2 vs 1', '⚔️ 3 vs 2', '🏃 Juegos de invasión']
  }, {
    title: 'Situaciones Reales',
    items: ['⚡ Ataques rápidos', '🛡️ Recuperación defensiva', '🎯 Espacios libres', '🤝 Juego colectivo']
  }, {
    title: 'Mini Partidos Adaptados',
    items: ['👥 Cantidad de jugadores', '📏 Medidas de cancha', '🔄 Roles rotativos', '🏉 Reglas simples']
  }, {
    title: 'Juegos Competitivos',
    items: ['🏆 Torneos internos', '🥇 Desafíos grupales', '🎮 Rugby + otros deportes', '🔥 Competencias recreativas']
  }, {
    title: '12 Clases Armadas',
    items: ['📋 Clase basada en juegos', '📋 Clase competitiva', '📋 Clase táctica infantil', '📋 Clase recreativa total']
  }],
  biblio: ['Teaching Games for Understanding', 'Rugby Games for Kids', 'Coaching Better Rugby']
}, {
  number: 6,
  title: 'PLANIFICACIÓN ANUAL + 100 CLASES ARMADAS',
  subtitle: 'La herramienta definitiva para toda la temporada',
  emoji: '📅',
  chapters: [{
    title: 'Cómo Planificar un Año Completo',
    items: ['📆 Objetivos trimestrales', '🎯 Progresiones técnicas', '🏉 Calendario anual', '📈 Evolución del jugador']
  }, {
    title: 'Planificación por Edades',
    items: ['🧒 4-6 años', '🧒 7-9 años', '🧒 10-12 años', '🔄 Diferencias metodológicas']
  }, {
    title: '100 Clases Listas para Usar',
    items: ['📋 25 clases iniciales', '📋 25 clases intermedias', '📋 25 clases avanzadas', '📋 25 clases recreativas']
  }, {
    title: 'Sesiones Especiales',
    items: ['🏉 Clase de ataque', '🛡️ Clase defensiva', '⚡ Clase física', '🎮 Clase de juegos']
  }, {
    title: 'Recursos para Entrenadores',
    items: ['💬 Frases motivadoras', '👏 Cómo corregir mejor', '📢 Cómo mantener disciplina', '🔥 Cómo hacer clases más dinámicas']
  }, {
    title: 'Eventos y Encuentros',
    items: ['🏆 Festivales infantiles', '🏉 Encuentros recreativos', '👨‍👩‍👧 Rugby familiar', '🎉 Actividades especiales']
  }],
  biblio: []
}];
export const TomosAccordion = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <div className="max-w-4xl mx-auto space-y-4" data-id="element-166">
      {tomos.map((tomo, i) => {
      const isOpen = openIdx === i;
      return <div key={i} className="bg-navy-900 rounded-2xl border border-navy-700 overflow-hidden transition-colors hover:border-rugby-blue/50" data-id="element-167">
            <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left" data-id="element-168">
              <div className="flex items-center gap-4 md:gap-5" data-id="element-169">
                <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-xl bg-rugby-blue/20 border border-rugby-blue/40 flex items-center justify-center text-2xl md:text-3xl" data-id="element-170">
                  {tomo.emoji}
                </div>
                <div data-id="element-171">
                  <div className="text-xs md:text-sm text-rugby-blue font-bold uppercase tracking-widest mb-1" data-id="element-172">
                    Tomo {tomo.number}
                  </div>
                  <h3 className="font-display text-xl md:text-3xl uppercase leading-tight" data-id="element-173">
                    {tomo.title}
                  </h3>
                  <p className="text-slate-400 text-sm md:text-base italic mt-1" data-id="element-174">
                    "{tomo.subtitle}"
                  </p>
                </div>
              </div>
              <ChevronDown className={`w-6 h-6 md:w-8 md:h-8 text-rugby-blue flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-175" />
            </button>

            {isOpen && <div className="px-5 md:px-6 pb-6 pt-2 border-t border-navy-700/60 animate-[fadeIn_0.25s_ease-out]" data-id="element-176">
                <div className="grid md:grid-cols-2 gap-5 mt-5" data-id="element-177">
                  {tomo.chapters.map((cap, ci) => <div key={ci} className="bg-navy-800 rounded-xl p-5 border border-navy-700" data-id="element-178">
                      <div className="flex items-center gap-2 mb-3" data-id="element-179">
                        <span className="text-rugby-blue font-bold text-sm" data-id="element-180">
                          Capítulo {ci + 1}
                        </span>
                      </div>
                      <h4 className="font-bold text-lg text-white mb-3 leading-snug" data-id="element-181">
                        {cap.title}
                      </h4>
                      <ul className="space-y-1.5" data-id="element-182">
                        {cap.items.map((item, ii) => <li key={ii} className="text-slate-300 text-sm leading-relaxed" data-id="element-183">
                            {item}
                          </li>)}
                      </ul>
                    </div>)}
                </div>

                {tomo.biblio.length > 0 && <div className="mt-6 bg-navy-800/60 rounded-xl p-5 border border-dashed border-navy-700" data-id="element-184">
                    <div className="flex items-center gap-2 mb-3" data-id="element-185">
                      <BookOpen className="w-5 h-5 text-rugby-blue" data-id="element-186" />
                      <h4 className="font-bold text-white uppercase tracking-wide text-sm" data-id="element-187">
                        Bibliografía Recomendada
                      </h4>
                    </div>
                    <ul className="space-y-1.5" data-id="element-188">
                      {tomo.biblio.map((book, bi) => <li key={bi} className="text-slate-400 text-sm flex items-start gap-2" data-id="element-189">
                          <span className="text-rugby-blue" data-id="element-190">📖</span>
                          <span data-id="element-191">{book}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>}
          </div>;
    })}
    </div>;
};